"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapBsStyleToColor = void 0;

var colors = _interopRequireWildcard(require("./colors"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// eslint-disable-next-line import/prefer-default-export
var mapBsStyleToColor = function mapBsStyleToColor(bsStyle) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$shade = _ref.shade,
      shade = _ref$shade === void 0 ? 'base' : _ref$shade,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? colors.coal : _ref$fallback;

  var result = colors[bsStyle];

  if (result && result[shade]) {
    result = result[shade];
  } else {
    result = fallback;
  }

  return result;
};

exports.mapBsStyleToColor = mapBsStyleToColor;